import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { IProductDataV3, Product } from '@df/catalog/product/product';
import { Url } from '@df/core/service/url';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { SocialShareAbstract } from '../../../../ui/social/social-share.abstract';

@Component({
    selector: 'product-social-share',
    templateUrl: './product-social-share.html',
    styleUrl: './product-social-share.scss',
    standalone: true,
    imports: [TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductSocialShareComponent extends SocialShareAbstract {
    @Input({ required: true })
    override model!: Product<IProductDataV3>;

    private url = inject(Url);

    shareIconsVisible = false;

    /**
     * Share button methods
     */

    openShareIcons() {
        this.shareIconsVisible = true;
        this.detectChanges();
    }

    closeShareIcons() {
        this.shareIconsVisible = false;
        this.detectChanges();
    }

    get shareByEmail(): string {
        const url = this.url.toUrl(this.model!.data!.url!);
        return `mailto:?subject=Hello! Do you know Oliver Bonas?&body=Hello, take a look at this Oliver Bonas product ${url}`;
    }
}
